































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'MobilePaymentResult',
  components: {},
})
export default class NotFoundError404 extends Vue {
  queryParams = null;
  loaded = false;
  @Prop({ type: [String, Number] }) readonly bookingEventId: string | number;
  @Prop({ type: [String, Number] }) readonly tenantId: string | number;

  get retryDone() {
    return this.queryParams?.retry_done?.toString() || '';
  }

  get deepLinkUrl() {
    const baseUrl = this.$clientRouter.isLocalHost()
      ? 'http://localhost:8002' // Add http://localhost:8100 later
      : this.$clientRouter.getDeepLinkBaseUrl();

    const queryParams = new URLSearchParams({
      retry_done: 'true',
    });

    return `${baseUrl}/mobile-app/${this.tenantId}/profile/bookings/${
      this.bookingEventId
    }?${queryParams.toString()}`;
  }

  get missingRequiredParams() {
    return !this.tenantId || !this.bookingEventId;
  }

  async mounted() {
    this.loaded = false;
    this.queryParams = this.$route.query;
    await this.loadTranslations();
    this.loaded = true;
  }

  async loadTranslations() {
    const lang = localStorage.getItem('lang') || 'fr';
    await this.translationService.getTranslations(lang);
  }

  async wait(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
